import React, { useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { Button, TextField } from '@material-ui/core';
import { LetterX } from 'tabler-icons-react';
import { useGeneral } from '../../Context/GeneralContext';
import '../../styles/modalConfirm.css';
import '../../styles/modalScrap.css';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: '90%',
        maxWidth: '760px',
        minWidth: '320px',
        height: 'fit-content',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
            width: '95%',
            maxWidth: '100%',
        },
    },
}));

export default function ModalScrap() {
    const { openScrap, setOpenScrap, setScrapData, setConfirm } = useGeneral();
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);
    const [piezasScrap, setPiezasScrap] = useState('');
    const [error, setError] = useState(false);

    const handleClose = () => {
        setOpenScrap(false);
        setPiezasScrap('');
        setError(false);
    };

    const handleConfirm = () => {
        const value = parseInt(piezasScrap);
        if (piezasScrap === '' || isNaN(value) || value < 0) {
            setError(true);
            return;
        }
        unstable_batchedUpdates(() => {
            setScrapData({ piezasMalas: value });
            setOpenScrap(false);
            setConfirm(true);
            setPiezasScrap('');
            setError(false);
        });
    };

    const body = (
        <div style={modalStyle} className={classes.paper}>
            <div className="modalConf-head modalScrap-head">
                <div className="modalConf-text modalScrap-head-text">
                    <h4 className="modalConf-text-field">Finalizar Corrida</h4>
                </div>
                <div className="modalConf-exit">
                    <LetterX
                        size={22}
                        color={'#ffffff'}
                        className="modalScrap-exit-icon"
                        onClick={handleClose}
                    />
                </div>
            </div>
            <div className="modalConf-body">
                <div className="modalScrap-body-text">
                    <p className="modalScrap-desc">
                        Ingrese la cantidad de piezas malas generadas durante la corrida antes de finalizar.
                    </p>
                    <div className="modalScrap-field">
                        <TextField
                            variant="outlined"
                            label="Piezas malas"
                            type="number"
                            value={piezasScrap}
                            onChange={(e) => {
                                setPiezasScrap(e.target.value);
                                setError(false);
                            }}
                            error={error}
                            helperText={error ? 'Ingrese un valor mayor o igual a 0' : ''}
                            inputProps={{ min: 0 }}
                            fullWidth
                        />
                    </div>
                </div>
                <div className="modalConf-body-buttons">
                    <div className="modalConf-body-buttons-first">
                        <Button
                            className="modalM-body-buttonS modalScrap-btn-confirm"
                            onClick={handleConfirm}
                        >
                            <h1 className="modalScrap-btn-confirm-text">Confirmar</h1>
                        </Button>
                    </div>
                    <div className="modalConf-body-buttons-second">
                        <Button
                            className="modalM-body-buttonC modalScrap-btn-cancel"
                            onClick={handleClose}
                        >
                            <h1>Cancelar</h1>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <Modal
                open={openScrap}
                onClose={handleClose}
                aria-labelledby="modal-scrap-title"
                aria-describedby="modal-scrap-description"
            >
                {body}
            </Modal>
        </div>
    );
}
